import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import './Header.css';

function Header() {
  const history = useHistory();

  const handleLogout = () => {
    // Remover o token ou qualquer dado de autenticação
    localStorage.removeItem('authToken');
    // Redirecionar para a página de login
    history.push('/login');
  };

  return (
    <header className='header'>
      <nav className='nav-menu'>
        <div className='logo-container'>
          <Link to='/' style={{ fontSize: 0 }}>
            <img
              alt='Logo'
              loading='lazy'
              width='97'
              height='37'
              decoding='async'
              className='header__logo'
              src='/logo.svg'
            />
          </Link>
        </div>
        <ul>
          <li>
            <Link to='/'>Home</Link>
          </li>
          <li>
            <Link to='/dashboard'>Separação</Link>
          </li>
          <li>
            <a
              href='https://app.ewti.com.br'
              target='_blank'
              rel='noopener noreferrer'
            >
              Pedido Rápido
            </a>
          </li>
        </ul>
        <div className='logout-container'>
          <button className='logout-button' onClick={handleLogout}>
            Logout
          </button>
        </div>
      </nav>
    </header>
  );
}

export default Header;
